export default "__VITE_ASSET__Cl0PcBvh__"